export const PATTERN_ID = 'diagonalHatch'
export const PATTERN_FILL = `url(#${PATTERN_ID})`
export const PATTERN_STROKE_WIDTH = 2
export const PATTERN_STROKE_SPACING = 3
export const PATTERN_ROTATION = 135
